// extracted by mini-css-extract-plugin
export default {"glass":"GlassDiv_glass__rOJQh"};